import { render, staticRenderFns } from "./Categorys.vue?vue&type=template&id=14e95e8a"
import script from "./Categorys.vue?vue&type=script&lang=js"
export * from "./Categorys.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports